import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import theme from '../../Theming/DefaultTheme';
import TextLink from '../TextLink';
var titleText = {
    color: theme.palette.primary.main,
    fontWeight: 600,
    textAlign: 'left',
};
var photosContainer = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: 200,
    overflow: 'hidden',
};
var infoWindowStyles = {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.common.white,
    width: 220,
    minHeight: 130,
};
var PlaceInfoWindow = function (_a) {
    var _b;
    var place = _a.place;
    var googleMapsUrl = "https://www.google.com/maps/search/?api=1&query=".concat(encodeURIComponent(place === null || place === void 0 ? void 0 : place.address));
    return (_jsxs(Box, { style: infoWindowStyles, children: [_jsx(Typography, { style: titleText, variant: 'h5', children: place.name }), _jsx(Typography, { variant: 'body2', children: place.address }), _jsx(TextLink, { onClick: function () { return window.open(googleMapsUrl, '_blank'); }, children: _jsx(Typography, { variant: 'caption', children: 'Directions' }) }), ((_b = place === null || place === void 0 ? void 0 : place.photos) === null || _b === void 0 ? void 0 : _b.length) > 0 && (_jsx(Box, { style: photosContainer, children: _jsx("img", { src: place.photos[0], alt: place.name, style: { height: '100%', width: 'auto', borderRadius: 8 } }) })), _jsx(Box, { style: { height: 20 } })] }));
};
export default PlaceInfoWindow;
